module.exports = __webpack_public_path__ + "static/media/10253.aa8dcd01.jpg";